<template>
    <div class="providerSection">
        <h1 style="margin: 0 auto;">
            <v-icon
                v-if="screen_width > 430"
                x-large
                elevation="10"
                class="white--text"
                style="height: 50px; width: 50px; background-color: #009688; border-radius: 25px; margin-right: 2%;"
            >
                {{ mdiShieldOutline }}
            </v-icon>
            <span>Data Privacy Statement</span>
        </h1>
        <v-card
            class="docInfoBody"
            elevation="2"
            style="margin: 2% auto 2% auto;"
        >
            <p style="font-weight: 700; margin-bottom: 30px;">
                Health Maintenance, Inc. is fully compliant with the Data Privacy Act of 2012.
            </p>
            <p>The personal and medical information to be gathered and processed by HMI are but not limited to: name, age, address, medical history, signs and symptoms, diagnosis, diagnostic test, treatment, therapeutic procedure and medical management, utilization, name of hospital, clinic and attending physician, date and length of confinement, accommodation, and medical costs; and similar data for dependents members (collectively referred to as “Information”). The purpose is for the processing medical claims as a prospective client and member of HMI and for marketing, historical and statistical purposes. </p>
            <p>The collection shall continue for as long as one is a client and member of HMI. The method of the processing of the data which is through collection by HMI employees with legitimate interest, licensed agents, HMI liaison officers from accredited hospitals and clinics, encoding at the computers of HMI at its Head Office, processing which will be done partly automatic; that the recipient to whom the Information shall be disclosed to are the employees of HMI or duly licensed HMI agents with legitimate interest to the said information. </p>
            <p>The personal information controller shall be HMI which can be contacted at 1152 Chino Roces Ave, San Antonio Village, Makati, 1203 and tel. no. (02)88111313. The Information shall be stored for a period of ten (10) years; and all parties agree that prospective HMI clients, and existing and past HMI members and their dependents are informed of the right to refuse to give this consent and to withdraw consent already given (right to object), right to access, correct inaccuracies, erase or block the Information or any part of it, right to data portability consisting of moving, transferring and copying of the Information securely; the right to lodge a complaint before the National Privacy Commission, as well as entitlement to damages in case of violation of our said rights, all granted and defined under R.A. 10173. </p>
            <p>For any concerns regarding the Data Privacy Policies of HMI, kindly contact our DPO: </p>
            <ul style="list-style-type: none; padding: 0;">
                <li><strong>Norman S. Francisco</strong></li>
                <li>Vice President For Marketing</li>
                <li>Sales And Marketing Division</li>
                <li>Office Numbers:  8811-1313 • 7752-0552 • 8865-3700</li>
            </ul>
        </v-card>
    </div>
</template>

<script>
import { mdiShieldOutline } from '@mdi/js'

export default {
    data: ()=>({
        mdiShieldOutline,
        screen_width: document.documentElement.clientWidth + 9
    }),
    mounted(){
        window.addEventListener('resize', this.onResize)
    },
    destroyed(){
        window.removeEventListener('resize', this.onResize)
    },
    methods: {
        onResize() {
            this.screen_width = document.documentElement.clientWidth
            this.screen_width = this.screen_width + 9
        }
    }
}
</script>

<style scoped>
h1 {
    font-size: 25px;
    padding: 10px;
    border-bottom: 1px solid #bbb;
}
.docInfoBody {
    margin-top: 5%;
    padding: 3%;
    background: rgba(255,255,255,0);
}
    .providerData {
        width: 90%;
        margin: 5% 5%;
    }
        .providerData tr td {
            padding: 1% 1%;
        }
            .docData {
                font-weight: 700;
            }
.providerSection {
    padding: 10px 7.5% 0 7.5%;
}
@media (max-width: 380px) {
  .providerSection {
    padding: 70px 7.5% 0 7.5%;
  }
}
@media (max-width: 599px) {
  .providerSection {
    padding: 70px 7.5% 0 7.5%;
  }
}
@media (min-width: 599px) and (max-width: 1264px) {
  .providerSection {
    padding: 70px 7.5% 0 7.5%;
  }
}
@media (min-width: 1264px) {
  .providerSection {
    padding: 10px 7.5% 0 7.5%;
  }
}
</style>
